<template>
  <div class="relative">
    <img
      :src="logo"
      alt="Logo"
      class="absolute left-1/2 top-[65.77px] z-10 w-1/2 max-w-[400px] -translate-x-1/2"
    />
    <img :src="ellipse" alt="Logo" class="absolute left-0 top-0 w-full" />

    <h1 class="mt-[250.44px] text-2xl font-semibold leading-[26px] text-white">Olá!</h1>
    <p class="mt-3 text-xl font-semibold leading-[26px] text-muted-gray">
      Informe o token de acesso para entrar
    </p>

    <AccessTokenInput
      class="mt-6"
      v-model="otpInput"
      @on-change="isLoginButtonEnabled = false"
      @on-complete="onTokenFilled"
    />

    <VButton
      class="mt-6"
      type="solid"
      title="Entrar"
      :callback="login"
      :disabled="!isLoginButtonEnabled"
    />
  </div>
</template>

<script setup lang="ts">
import ellipse from '@/assets/ellipse.svg'
import logo from '@/assets/ssn-logo.png'

import AccessTokenInput from '@/components/AccessTokenInput/AccessTokenInput.vue'
import VButton from '@/components/Button/VButton.vue'
import { ref } from 'vue'

const emit = defineEmits(['on-login'])

const otpInput = ref('')
const isLoginButtonEnabled = ref(false)

async function onTokenFilled() {
  isLoginButtonEnabled.value = true
  await login()
}

async function login() {
  emit('on-login', otpInput.value)
}
</script>
